export default __webpack_public_path__ + "static/media/a023-startup4-en-short.58b75e5c.png";